/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_Nav_DInputs */

const en_mk_sol_operasional_nav_d = /** @type {(inputs: Mk_Sol_Operasional_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeating processes that have to run on time, every day.`)
};

const id_mk_sol_operasional_nav_d = /** @type {(inputs: Mk_Sol_Operasional_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proses berulang yang harus jalan tepat waktu, tiap hari.`)
};

/**
* | output |
* | --- |
* | "Repeating processes that have to run on time, every day." |
*
* @param {Mk_Sol_Operasional_Nav_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_nav_d = /** @type {((inputs?: Mk_Sol_Operasional_Nav_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_Nav_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_nav_d(inputs)
	return en_mk_sol_operasional_nav_d(inputs)
});